import styled from 'styled-components';
import { Colors } from '../../../types/types';
import { devices } from '../../../styles/viewports';

export const TableContainer = styled.table`
  border-collapse: collapse;
`;

export const Container = styled.div`
  overflow-x: auto;
`;

export const Wrapper = styled.div`
  width: 100%;
`;

export const TableHeader = styled.th<{ columns: number; lineColor: Colors }>`
  font-size: var(--font-size-subtitle-2);
  font-family: var(--font-family-subtitle);
  font-feature-settings: var(--font-feature-settings-subtitle);
  font-weight: var(--font-weight-subtitle-2);
  letter-spacing: var(--letter-spacing-subtitle-2);
  line-height: var(--line-height-subtitle-2);
  padding: 30px 30px 30px 0;
  text-align: left;
  text-transform: uppercase;
  border-bottom: 1px solid;
  border-top: 1px solid;
  border-color: ${(props) => `var(--base-color-${props.lineColor})`};

  &:last-child {
    white-space: nowrap;
    width: auto;
  }

  &:not(:last-child) {
    width: ${(props) => `calc(100% / ${props.columns - 1})`};
  }

  @media ${devices.tablet} {
    &:last-child {
      white-space: nowrap;
    }
  }

  @media ${devices.mobile} {
    padding: 20px 20px 20px 0;

    &:last-child {
      white-space: normal;
    }
  }
`;

export const TableCell = styled.td<{ columns: number; lineColor: Colors }>`
  font-size: var(--font-size-body-1);
  font-family: var(--font-family-body);
  font-feature-settings: var(--font-feature-settings-body);
  font-weight: var(--font-weight-body-1);
  letter-spacing: var(--letter-spacing-body-1);
  line-height: var(--line-height-body-1);
  padding: 30px 30px 30px 0;
  text-align: left;
  vertical-align: top;
  border-bottom: 1px solid;
  border-color: ${(props) => `var(--base-color-${props.lineColor})`};

  &:last-child {
    width: auto;
  }

  &:not(:last-child) {
    width: ${(props) => `calc(100% / ${props.columns - 1})`};
  }

  > span > svg {
    width: 24px;
    height: 24px;
  }

  @media ${devices.mobile} {
    padding: 20px 20px 20px 0;
  }
`;

export const Pagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  flex-wrap: nowrap;
  flex-direction: row;
  list-style: none;
  max-width: fit-content;
  margin: auto;
  li {
    font-size: var(--font-size-subtitle-1);
    font-weight: var(--font-weight-body-1);
    line-height: var(--line-height-subtitle-1);
    letter-spacing: var(--letter-spacing-subtitle-1);
    margin-left: 16px;
    color: var(--base-color-dark-grey);
    display: flex;
    align-items: center;
    border-bottom: none;
  }
`;

export const PageNumber = styled.button<{ active?: string }>`
  background: none;
  border: none;
  padding: 0;
  font-size: inherit;
  color: inherit;
  cursor: pointer;
  display: inline-block;
  margin: 0;
  border-bottom: 1px solid var(--base-color-transparent);
  line-height: var(--base-line-height);
  text-decoration: none;
  font-family: var(--font-family-body-1);

  :hover {
    outline: none;
    color: var(--base-color-core);
    border-bottom: 1px solid var(--base-color-core);
    svg > path {
      fill: var(--base-color-core);
    }
  }

  /* Active state */
  ${({ active }) =>
    active === 'true' &&
    `
      color: var(--base-color-core);
      border-bottom: 1px solid var(--base-color-core);
    `}
`;

export const Next = styled.span`
  display: inline-flex;
  width: 25px;
  align-items: center;
  justify-content: center;
  margin-left: 0;
  span {
    height: 1.5em;
    svg > path {
      fill: var(--base-color-dark-grey);
    }
  }
`;

export const ScrollButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 0 24px 0;

  div:hover {
    background-color: var(--base-color-light-grey);
  }

  > div > div {
    background-color: var(--base-color-light-grey);
  }

  svg path {
    fill: var(--base-color-black) !important;
  }
`;

export const AriaDescription = styled.span`
  position: absolute;
  left: -9999px;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;
